export default __webpack_public_path__ + "static/media/white_terminate.07ca40e7.svg";